import { Head } from 'arcway/lib/client'

import { DocumentationArticle } from '#components/documentation.jsx'

export function DocumentationPage({ article, articles }) {
  return (
    <>
      <Head
        description={article.description}
        title={`${article.title} — mono.fm`}
      >
        <link href={`/docs/${article.slug}`} rel='canonical' />
      </Head>
      <DocumentationArticle article={article} articles={articles} />
    </>
  )
}
